import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=373a0ef4&scoped=true"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=373a0ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a0ef4",
  null
  
)

export default component.exports